import { Pipe, PipeTransform } from '@angular/core';

import { FILE_ORIGIN_BADGES } from '@properties/file-attachment.properties';
import { RecordOriginBadgeInterface } from '@interfaces/record-origin-badge.interface';

/** Resolves the origin badge ("SR File" / "Leg File") for a file row, or null when unknown. */
@Pipe({
  name: 'fileOriginBadge',
  standalone: true,
})
export class FileOriginBadgePipe implements PipeTransform {
  transform(uploadedFrom: string | null | undefined): RecordOriginBadgeInterface | null {
    return uploadedFrom ? (FILE_ORIGIN_BADGES[uploadedFrom] ?? null) : null;
  }
}
